import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ListView from './views/ListView';
import BaseLayout from '../../components/CabinetBaseLayout';
import { DankaiForm } from './views/FormView';
import InfoView from './views/InfoView';
import useUser from '../../auth/hooks';
import { getBasePath } from '../../utils/urls';
import { canEditDankai, canViewDankai } from '../../utils/permissions';

const Component = () => {
  const { user } = useUser();
  const ctxName = getBasePath(user)
  return (
    <BaseLayout>
      <Switch>
        {canViewDankai(user) && (
          <Route exact path={`/${ctxName}/dankai`} component={ListView} />
        )}
        {canViewDankai(user) && (
          <Route exact path={`/${ctxName}/dankai/:type/:id`} component={InfoView} />
        )}
        {canEditDankai(user) && (
          <Route exact path={`/${ctxName}/dankai/:type/:id/edit`} component={DankaiForm} />
        )}
      </Switch>
    </BaseLayout>
  );
};

export default Component;
